import { useConfigStore } from '@packages/stores';
import { hasPreCancellationBoostPrice } from '@packages/utils';

import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';
import { useTripStore } from '@store';

export const LegalConsentListItems = () => {
  const isPreTripCancellationEligible = useTripStore(state =>
    hasPreCancellationBoostPrice(state.trip),
  );

  const termsOfUseLink = useConfigStore(state => state?.regionSpecificConfig?.APP_TERMS);

  const legalListItems = i18n.t('checkout.legal', {
    returnObjects: true,
    termsAndConditions: termsOfUseLink,
  });

  const nonEligibleLegalItem =
    !isPreTripCancellationEligible && legalListItems?.find(i => i?.type === 'nonEligible');

  return (
    <ul className="flex-1">
      {nonEligibleLegalItem && (
        <li className="mb-8 first:mt-6 last:mb-6">
          <TextWithMd variant={'body-16/sb'} className="mb-2 text-red-500">
            {nonEligibleLegalItem?.title}
          </TextWithMd>
          <TextWithMd variant={'body-16/m'} className="mb-2">
            {nonEligibleLegalItem?.description}
          </TextWithMd>
        </li>
      )}
      {legalListItems
        ?.filter(i => !i?.type)
        .map(item => (
          <li key={item.title} className="mb-8 first:mt-6 last:mb-6">
            <div className="[&_a]:text-fuji-600">
              <TextWithMd variant="body-16/m">{item.title}</TextWithMd>
            </div>
          </li>
        ))}
    </ul>
  );
};
